import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/login/login-remember-me-constant';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../../models/login';
import { LoginRememberMeUtilsService } from '../../../../utils/login/login-remember-me-utils.service';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';

@Injectable({
  providedIn: 'root'
})
export class LoginPostWithCredService {
  loginAuthHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.checkUsernamePassword+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: LoginRememberMeUtilsService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginPostWithCredentials = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    userInputFields: ILoginUserNamePasswordInput
  ): Observable<LoginAuthWithCredentialsResponse> => {
    let userNamePingFlow = '';

    if (userInputFields.lastName) {
      userNamePingFlow = `${userInputFields.userName}${userInputFields.lastName}`;
    } else {
      userNamePingFlow = userInputFields.userName;
    }

    const payload: PostWithCredentials = {
      username: userNamePingFlow,
      password: userInputFields.password
    };

    const getLoginPostWithCredentialsUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginPostWithCredentialsUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginPostWithCredentialsUrl
      }
    ];

    return new ApiBuilder<
      PostWithCredentials,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginPostWithCredentialsUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAuthHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_POST_WITH_CREDENTIALS_SERVICE')
      .withCredentials(true)
      .create();
  };
}
